import useInterval from 'hooks/useInterval'
import moment from 'moment-timezone'
import { useState } from 'react'
import { useSelector } from 'react-redux'

const LocalTime = ({ id }) => {
  function getTime() {
    return id ? moment().tz(id).format('hh:mm A') : undefined
  }

  const [time, setTime] = useState(getTime())

  useInterval(() => {
    setTime(getTime())
  }, 60000)

  return time
}

const HotelLocalTime = ({ timeZoneId }) => {
  const ianaTimeZoneId = useSelector(s => s.hotelDetails.ianaTimeZoneId)

  const id = timeZoneId || ianaTimeZoneId

  if (moment.tz.names().includes(id)) {
    return <LocalTime id={id} />
  } else {
    console.warn(`not showing time, unrecognized timeZoneId ${id}`)
  }

  return null
}

export default HotelLocalTime
